import axios from 'axios';
import { getToken } from '../../../actions/auth.js';

const getCollectorBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000/collector-api';
  }
  return process.env.REACT_APP_BACKEND_URL;
};

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
});

export const checkEnvironmentImport = (snapshot, targets, gameFactStrategy) =>
  axios.post(
    `${getCollectorBaseUrl()}/admin/environment-import/check`,
    { snapshot, targets, gameFactStrategy },
    getHeaders()
  );

export const executeEnvironmentImport = (snapshot, targets, gameFactStrategy, planFingerprint) =>
  axios.post(
    `${getCollectorBaseUrl()}/admin/environment-import/execute`,
    { snapshot, targets, gameFactStrategy, planFingerprint },
    getHeaders()
  );

export const getEnvironmentImportReports = (params = {}) =>
  axios.get(
    `${getCollectorBaseUrl()}/admin/environment-import/reports`,
    {
      ...getHeaders(),
      params,
    }
  );

export const getEnvironmentImportReportById = (id) =>
  axios.get(
    `${getCollectorBaseUrl()}/admin/environment-import/reports/${id}`,
    getHeaders()
  );
